module.exports = __webpack_public_path__ + "img/barcavelaWhite.6ac6060c.svg";